import { createSlice } from "@reduxjs/toolkit";

import { RootState } from './../../index';
import { DispatchType } from "../..";
import userAccountsService from "../../../../services/api/user-accounts/userAccountsService";


const initialState = {
    list: {} as { [index: number]: any[] },
    loading: true,
    filters: null,
    pager: {
        pageSize: 0,
        page: 1,
        totalCount: 0
    },
    loadingError: false
};


const slice = createSlice({
    name: "userAccounts",
    initialState: initialState,
    reducers: {
        userAccountsRequested: (state, action) => {
            state.loading = true;
            state.filters = action.payload.filters;
            state.pager.page = action.payload.page;
            state.loadingError = false;
        },
        userAccountsReceived: (state, action) => {
            state.list[action.payload.pager.page] = action.payload.data;
            state.pager = action.payload.pager;
            state.loading = false;
        },
        userAccountsRequestFailed: (state, action) => {
            state.loadingError = true;
            state.loading = false;
        },
        updateAccountRecord: (state, action) => {
            const { account, page } = action.payload;

            const list = state.list[page];
            if (list) {
                const index = list.findIndex(accountItem => accountItem.id === account.id);
                list[index] = { ...account };

                state.list[page] = list;
            }
        },
        getCachedAccounts: (state, action) => {
            state.pager.page = action.payload.page;
        },
        clearCachedAccounts: (state, action) => {
            state.list = {};
        },
        resetAccounts: (state, action) => initialState,
    }
});


const { userAccountsRequested, getCachedAccounts, userAccountsRequestFailed, userAccountsReceived, clearCachedAccounts } = slice.actions;
export const { resetAccounts, updateAccountRecord } = slice.actions;




// Actions
export const loadUserAccounts = (payload: any) => async (dispatch: DispatchType, getState: () => RootState) => {
    const accounts = getState().entities.userAccounts;
    const sameFilters = JSON.stringify(payload.filters) === JSON.stringify(accounts.filters);

    // load from cache when page is already loaded
    if (accounts.list[payload.page] && sameFilters) {
        dispatch(getCachedAccounts({
            page: payload.page
        }));

        return;
    }


    if (!sameFilters) {
        dispatch(clearCachedAccounts({}));
    }


    dispatch(userAccountsRequested(payload));
    const result = await userAccountsService.getAccounts({
        ...payload.filters,
        page: payload.page,
        pageSize: 10,
        direction: 'desc',
        properties: 'id',
    });

    if (result.success) {
        dispatch(userAccountsReceived(result));
    } else {
        dispatch(userAccountsRequestFailed({}));
    }
};




// Selectors
export const selectUserAccounts = (state: RootState): ListSelectorType => {
    const accounts = { ...state.entities.userAccounts };
    accounts.list = accounts.list[state.entities.userAccounts.pager.page] || [];

    return accounts as ListSelectorType;
};


type ListSelectorType = Omit<typeof initialState, 'list'> & {
    list: any[];
}


export default slice.reducer;